export const content = {
  StartToCode: {
    de: 'Start To Code',
    en: 'Start To Code',
    sv: 'Börja Koda',
  },
  StartWith: {
    en: 'Start with',
    sv: 'Börja med',
    de: 'Beginnen mit',
  },
  AreYouReadyTo: {
    en: 'Are you ready to',
    sv: 'Är du redo att',
    de: 'Bist du bereit zu',
  },
  AreYouReadyToParagraph: {
    en: 'Become a better developer through fun code challenges and games.',
    sv: 'Bli en bättre utvecklare genom roliga kodutmaningar och spel.',
    de: 'Werden Sie durch unterhaltsame Code-Herausforderungen und Spiele ein besserer Entwickler.',
  },
  UpYourCode: {
    en: 'Up your code',
    sv: 'Förbättra din kod',
    de: 'Erweitern Sie Ihren Code',
  },
  UpYourCodeParagraph: {
    en: 'Perhaps you are fluent in Java, but want to learn Python? With several programming languages to choose from you have the opportunity to hone your skills and become a better coder. Or, learn programming from scratch, free of charge.',
    sv: 'Kanske är du flytande i Java, men vill lära dig Python? Med flera programmeringsspråk att välja mellan har du möjlighet att finslipa dina kunskaper och bli en bättre kodare. Eller, lär dig programmering från grunden utan kostnad.',
    de: 'Vielleicht sprechen Sie fließend Java, möchten aber Python lernen? Da Sie aus mehreren Programmiersprachen wählen können, haben Sie die Möglichkeit, Ihre Fähigkeiten zu verbessern und ein besserer Programmierer zu werden. Oder, lernen Sie das Programmieren von Grund auf kostenlos.',
  },
  FunForAllH: {
    en: 'Fun-for-All code challenge',
    sv: 'Kul-för-alla kodutmaning',
    de: 'Spaß-für-Alle-Code-Challenge',
  },
  FunForAllP1: {
    en: 'Put your programming skills to the test in our playful code challenges and see if you have what it takes to rise to the next level.',
    sv: 'Sätt dina programmeringskunskaper på prov i våra lekfulla kodutmaningar och se om du har vad som krävs för att ta dig till nästa nivå.',
    de: 'Stellen Sie Ihre Programmierkenntnisse in einer unserer spielerischen Code-Herausforderungen auf die Probe und finden Sie heraus, ob Sie das Zeug dazu haben, die nächste Stufe zu erreichen.',
  },
  FunForAllP2: {
    en: 'The code challenges are fun, inspired by retro games, where the final result is based on the quality of your code.',
    sv: 'Kodutmaningarna är roliga, inspirerade av retrospel, där slutresultatet baseras på din kodkvalité',
    de: 'Bei den Code-Herausforderungen handelt es sich um unterhaltsame Spiele im Retro-Stil, bei denen das Endergebnis von der Qualität Ihres Codes abhängt.',
  },
  HowDoesItWork: {
    en: 'How does it work?',
    sv: 'Hur funkar det?',
    de: 'Wie funktioniert es?',
  },
  MembershipH: {
    en: 'No membership needed',
    sv: 'Inget medlemskap behövs',
    de: 'Keine Mitgliedschaft erforderlich',
  },
  MembershipP: {
    en: "Start coding! It doesn't get any easier than that.",
    sv: 'Börja koda! Enklare än så blir det inte.',
    de: 'Beginnen Sie mit dem Codieren! Einfacher geht es nicht.',
  },
  PotentialH: {
    en: 'Unlock your potential',
    sv: 'Lås upp din potential',
    de: 'Entfalten Sie Ihr Potenzial',
  },
  PotentialP: {
    en: 'Unlock code challenges, track your progress & become a skilled coder. Sign up with Facebook or Google.',
    sv: 'Lås upp kodutmaningar, spåra dina framsteg och bli en skicklig kodare. Registrera dig med Facebook eller Google.',
    de: 'Schalten Sie Code-Herausforderungen frei, verfolgen Sie den Fortschritt und werden Sie ein erfahrener Programmierer. Melden Sie sich bei Facebook oder Google an.',
  },
  FreeH: {
    en: '100% free',
    sv: '100% gratis',
    de: '100% kostenlos',
  },
  FreeP: {
    en: 'Free programming learning, no limits, costs or trial periods. Grab a coffee & start coding now.',
    sv: 'Gratis programmeringsinlärning, inga gränser, kostnader eller provperioder. Ta en kaffe och börja koda nu.',
    de: 'Kostenloses Programmierenlernen, keine Grenzen, Kosten oder Testzeiträume. Schnappen Sie sich einen Kaffee und beginnen Sie jetzt mit dem Programmieren.',
  },
  LearnFromPeersH: {
    en: 'Learn from your peers',
    sv: 'Lär av dina kamrater',
    de: 'Lernen Sie von Ihren Kollegen',
  },
  LearnFromPeersP1: {
    en: 'The best way to develop your skills is to be around like minded enthusiasts. Become a part of our programming forum to pick up new programming languages, compare algorithms and gain insight into different programming solutions.',
    sv: 'Det bästa sättet att utveckla dina färdigheter är att vara runt likasinnade entusiaster. Bli en del av vårt programmeringsforum för att lära dig nya programmeringsspråk, jämföra algoritmer och få insikt i olika programmeringslösningar.',
    de: 'Der beste Weg, Ihre Fähigkeiten zu entwickeln, besteht darin, mit gleichgesinnten Enthusiasten zusammen zu sein. Werden Sie Teil unseres Programmierforums, um neue Programmiersprachen zu erlernen, Algorithmen zu vergleichen und Einblicke in verschiedene Programmierlösungen zu erhalten.',
  },
  LearnFromPeersP2: {
    en: 'Experience unparalleled convenience and support in your programming journey from the comfort of your home.',
    sv: 'Upplev oöverträffad bekvämlighet och support i din programmeringsresa från bekvämligheten av ditt hem.',
    de: 'Erleben Sie beispiellosen Komfort und Support bei Ihrer Programmierreise bequem von zu Hause aus.',
  },
  ImproveYourChance: {
    en: 'Challenge yourself and improve your chances of succeeding with programming.',
    sv: 'Utmana dig själv och förbättra dina chanser att lyckas med programmering.',
    de: 'Es ist eine großartige Möglichkeit, sich selbst herauszufordern, Ihren Code auszuprobieren und Ihre Erfolgschancen beim Programmieren zu verbessern.',
  },
};
